export const createCategoryFromAssessment = (
  assessment: AssessmentSchema
): CategorySchema => {
  return {
    id: assessment.uuid,
    slug: assessment.uuid,
    title: 'Planning de révision',
    childrenType: null,
    contentType: ContentTypes.Assessment,
    children: assessment.chapterIds.map((id) => {
      return {
        type: 'category',
        id,
      };
    }),
  };
};
